import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import _ from 'lodash';
import classnames from 'classnames';

import './style.css';

class FilterGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      values: []
    };
  }

  onChange = (values) => {
    this.setState({ values });
    this.props.onchange(values);
  };

  renderFilters = () => {
    let filterList = this.props.filters[this.props.filterType];

    try {
      filterList = filterList.filter((filter) => !['Vape', 'Oral Tobacco'].includes(filter.name)).map(curr => {
        return (
          <ToggleButton key={`${this.props.idKey}_${curr.id}`}
            className={classnames({ 'filtered': this.props.values.length })}
            value={curr.id}>
            <div className="filter-name">{curr.name}</div>
          </ToggleButton>
        );
      });

      return filterList;
    } catch (error) {
      return '';
    }
  };

  render() {
    return (
      <Row className={classnames('filter-group', this.props.className)}>
        <Col lg={12} md={12} sm={12}>
          <ButtonToolbar>
            <ToggleButtonGroup type="checkbox"
              value={this.props.values}
              onChange={this.onChange}>
              {this.renderFilters()}
            </ToggleButtonGroup>
          </ButtonToolbar>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.orders.new.filters
  };
};

export default connect(mapStateToProps)(FilterGroup);



// WEBPACK FOOTER //
// ./src/components/new-order/filters/filter-group.jsx